// Signal Engineering Workshop Resources — page entry point.
// Composes the page from independent feature modules. All animation/motion
// lives in ./motion.js; swipers in ./swiper-sewr.js.

import { initSwipersWithResize } from './swiper-sewr.js';
import { initSewrMotion } from './motion.js';

// ─── Swipers ──────────────────────────────────────────────────────────────────
initSwipersWithResize();

// ─── All page motion: section reveals ────────────────────────────────────────
initSewrMotion();
